var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pagination-container" },
    [
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.listQuery.page,
          "page-sizes": _vm.pageSizes ? _vm.pageSizes : [15],
          "page-size": Number(_vm.listQuery.limit),
          total: _vm.listQuery.total,
          background: "",
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }